import React from 'react';
import config from '../config';

function EvidenceViewerModal({ evidence, onClose, user, onEdit, onDelete }) {
  const handleEdit = () => {
    onEdit(evidence);
    onClose();
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this evidence?')) {
      await onDelete(evidence.id);
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal evidence-viewer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{evidence.title}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {evidence.image_path && (
            <div className="evidence-image-full">
              <img
                src={`${config.baseUrl}${evidence.image_path}`}
                alt={evidence.title}
                width="100%"
              />
            </div>
          )}

          <div className="evidence-details-section">
            <div className="evidence-detail-row">
              <strong>Class:</strong> {evidence.class_name}
            </div>
            <div className="evidence-detail-row">
              <strong>Added by:</strong> {evidence.user_name}
            </div>
            <div className="evidence-detail-row">
              <strong>Date:</strong> {new Date(evidence.created_at).toLocaleDateString()}
            </div>
            {evidence.level && (
              <div className="evidence-detail-row">
                <strong>Level:</strong> {evidence.level.charAt(0).toUpperCase() + evidence.level.slice(1)}
              </div>
            )}
            {evidence.reach && (
              <div className="evidence-detail-row">
                <strong>Reach:</strong> {evidence.reach.charAt(0).toUpperCase() + evidence.reach.slice(1)}
              </div>
            )}
          </div>

          {evidence.description && (
            <div className="evidence-description-full">
              <strong>Description:</strong>
              <p>{evidence.description}</p>
            </div>
          )}
        </div>

        {user && user.id === evidence.user_id && (
          <div className="modal-actions">
            <button className="edit-btn" onClick={handleEdit}>
              Edit Evidence
            </button>
            <button className="delete-btn" onClick={handleDelete}>
              Delete Evidence
            </button>
          </div>
        )}

        {(!user || user.id !== evidence.user_id) && (
          <div className="modal-actions">
            <button className="cancel-btn" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EvidenceViewerModal;
